import styled from "styled-components/macro";
import { zIndexes, hexToRGBA } from "../../../utils";

const getGlassBackground = ({ glassOpacity, theme }) =>
  hexToRGBA(theme.color.neutral["01"], Math.min(Math.max(glassOpacity, 0), 1));

export const GlassContainer = styled.div`
  display: none;
  position: fixed;
  background-color: ${getGlassBackground};
  z-index: ${({ zIndex = zIndexes.glass }) => Math.min(zIndex, zIndexes.glass)};
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  &.active {
    display: block;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 300ms;
  }

  @keyframes fadeInOpacity {
    0% {
      background-color: transparent;
    }
    100% {
      background-color: ${getGlassBackground};
    }
  }
`;

export default null;
